import $ from 'jquery';
import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';

const joinTheTribe = {
    variables:{
        swiperFreeAutoplay:'.swiper__free--autoplay',
        swiperTickerDirection:'ticker-direction',
        url: window.location.href,
    },
    methods:{
        initSwiper: function(selector){
            const $slider = $(selector);
            $slider.each((_index, element) => {
                const direction = $(element).data(joinTheTribe.variables.swiperTickerDirection);
                new Swiper(element, {
                    loop: true,
                    modules:[Autoplay],
                    wrapperClass: 'swiper-wrapper',
                    slidesPerView: 'auto',
                    direction: 'horizontal',
                    spaceBetween: 0,
                    freeMode: true,
                    freeModeMomentum: false,
                    freeModeMomentumBounce: false,
                    speed: 2000,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: true,
                        reverseDirection: direction === 'left' ? true : false,
                    },
                    noSwiping:true,
                breakpoints: {
                    280: {
                        slidesPerView: 1.8,
                        spaceBetween: 16
                    },
                    500:{
                        slidesPerView: 2.5,
                        spaceBetween: 16,
                    },
                    720: {
                        slidesPerView: 2.8,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3.5,
                        spaceBetween: 20,
                    },
                    1200:{
                        slidesPerView:4.5,
                        spaceBetween:20
                    }
                }
                });
            });

            joinTheTribe.methods.customWidthHandler();

        },

        customWidthHandler: function(){
$(".join-tribe--slide").each((idx, elem) => {
    const feedback = $(elem).find('.join__tribe__card--feedback').data('feedback');
    const name = $(elem).find('.join__tribe__card--emp-name').data('emp-name');
    const desg = $(elem).find('.join__tribe__card--emp-desg').data('emp-desg');
    // A slide with an empty field has no element for it (data-sly-test), so
    // reading .length used to throw here and end the loop. Stop the loop the
    // same way, without the console error, so later slides are unchanged.
    if (feedback == null || name == null || desg == null) {
        return false;
    }
    let feedbackWidth = feedback.length;
    let nameWidth = name.length;
    let desgWidth = desg.length;
    if(feedbackWidth + nameWidth + desgWidth > 70){
        $(elem).addClass('custom-width-join__tribe');
    }
});

        },

        joinTheTribeButtonClickHandler: function () {
                       $('.join__tribe--cta').on('click', function(){
                              var buttonText =document.querySelector('.join__tribe--cta').children[0].innerText;
                              var obj = joinTheTribe.methods.dataLayerObj(buttonText);
                              createDataLayer('buttonClick', obj);
                       });
                     },

        dataLayerObj: function (e) {
                  var obj = {
                    'articleName': "",
                    'blogCategory': "",
                    'blogPageCategory': "",
                    'buttonText': e?e.replace(/\n/g, '').trim():"",
                    'pageSection': "Join The Tribe",
                    'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? joinTheTribe.variables.url.includes("blog") ? "Blogs" : joinTheTribe.variables.url.substring(joinTheTribe.variables.url.indexOf(".com/"), joinTheTribe.variables.url.lastIndexOf('/')  === ".com") && !joinTheTribe.variables.url.substring(joinTheTribe.variables.url.indexOf(".com/"), joinTheTribe.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                    'planOption': "",
                    'productCategory': "",
                    'productName': "",
                    'question': "",
                    'source': "",
                    'searchTerm': "",
                    'videoTitle': "",
                    'bannerName': "",
                  };
                  return obj;
                },
        init:function(){
            this.initSwiper(joinTheTribe.variables.swiperFreeAutoplay);
        }
    }
};

$(() => {
    if ($(".swiper__free--autoplay").length > 0) {
      joinTheTribe.methods.init();
    }
  });

$(document).ready(function () {
joinTheTribe.methods.joinTheTribeButtonClickHandler();
});

export default joinTheTribe;
